<template>
    <GrindingOrderIndex 
        v-if="id"
        :schedule_id="id"
    />
</template>

<script>
import { getCollection } from '@/shared/fetch-utils';
import moment from 'moment';
import GrindingOrderIndex from '@/pages/lab/schedule/GrindingOrderIndex.vue';

export default {
    name: "GrindOrderLoader",
    components: { GrindingOrderIndex },
    props: {
        sample_id: {
            type: String,
            default: () => null,
        },
        schedule_task_type: {
            type: String,
            default: () => null,
        },
        schedule_task_id: {
            type: String,
            default: () => null,
        },
    },
    data() {
        return {
            today: moment().format("YYYY-MM-DD"),
            id: null
        };
    },
    methods: {
        async init() {
            // get a schedule collection using the props and current date as filters
            const scheduleCollection = await getCollection({
                collection_type: "schedule",
                filters: this.compileFilters()
            });
            this.id = scheduleCollection.models[0].id
        },
        compileFilters() {
            let filter = [];
            filter.push({
                logic: "filterEquals",
                field: "sample_type_id",
                value: this.sample_id
            });
            filter.push({
                logic: "filterEquals",
                field: "process_type",
                value: this.schedule_task_type.charAt(0).toUpperCase() + this.schedule_task_type.slice(1)
            });
            filter.push({
                logic: "filterEquals",
                field: "date",
                value: this.today
            });
            // set up the list of filters 
            return filter;
        }
    },
    mounted() {
        this.init();
    },
};
</script>